<template>
  <tr class="w-table-row" :class="object.listClasses">
    <td v-if="showCheckbox" class="text-center">
      <input v-model="object.checked" aria-label="Zaznacz wiersz" class="mt-2" type="checkbox" @change="check" />
    </td>

    <td
      v-for="(column, index) in columns"
      :key="column.name + index"
      class="column-action middle"
      @click="$emit(column.action || defaultColumnAction, object)"
      v-html="getValue(object, column)"
    />

    <actions :actions="actions" :entity-type="entityType" :object="object" :id-key="idKey" v-on="$listeners" />
  </tr>
</template>

<script>
import Actions from './Actions';
import { VIEW_ACTION } from '@/utils/constants';
import { getColumnValue } from '@/utils/getColumnValue';

// @vuese
// Rzędy w tabeli
// @group Table
export default {
  name: 'TRow',
  components: { Actions },
  props: {
    // Kolumny do wyświetlenia
    columns: { type: Array, required: true },
    // Obiekt zawierający dane
    object: { type: Object, required: true },
    // Index obiektu
    objectIndex: { type: Number, required: true },
    // Możliwe do wykonania akcje
    actions: { type: Array, required: false, default: () => [] },
    // Typ encji wyświetlanej w tabeli
    entityType: { type: String, required: false },
    // Klucz identyfikatora
    idKey: { type: String, required: false, default: 'id' },
    // Edytowanie wielu
    showCheckbox: { type: Boolean, required: true },
    // Domyślna akcja po kliknięciu w kolumnę
    defaultColumnAction: { type: String, required: false, default: VIEW_ACTION.event }
  },
  methods: {
    // @vuese
    // Pobiera wartość wybranego pola
    getValue(object, column) {
      const value = getColumnValue({ ...object, index: this.objectIndex + 1 }, column);
      if (typeof value === 'string') {
        return value.replace(/\n/g, '<br>');
      }
      return value;
    },
    // @vuese
    // Zaznacza wiersz
    check(value) {
      this.$emit('checked', this.object);
    }
  }
};
</script>

<style>
.column-action:hover,
.w-table-row:hover td {
  cursor: pointer;
  background-color: #f0f0f0;
}
.middle {
  vertical-align: middle !important;
}
.dataTable td p {
  margin-bottom: 0;
}
</style>
